import AuthSignUpConfirmation from './Confirmation'

export default AuthSignUpConfirmation
